const STORAGE_KEY = "rpgcoin_session_fp";

/**
 * Returns a stable session fingerprint for the current browser.
 * Used to count unique ad views without requiring login.
 */
export const getSessionFingerprint = (): string => {
  let fp = localStorage.getItem(STORAGE_KEY);
  if (fp) return fp;

  fp = crypto.randomUUID();
  localStorage.setItem(STORAGE_KEY, fp);
  return fp;
};
